import { render } from "./OperarioDatosDatos.vue?vue&type=template&id=0a68d161"
import script from "./OperarioDatosDatos.vue?vue&type=script&lang=js"
export * from "./OperarioDatosDatos.vue?vue&type=script&lang=js"

import "./OperarioDatosDatos.vue?vue&type=style&index=0&id=0a68d161&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__